<div class="logo" *ngIf="icId == 13312">
  <img src="{{imagePath}}">
  <p class="address">
    Mount Poonamallee Road, P.O.Box 979, Manapakkam , Chennai - 600089 Ph : 91-44-2252 6000 / 2252 8000 , Fax :
    91-44-2252 6042
  </p>
  <p class="address">
    7th Floor, L&T Business Park, Gate -5 Powai , Mumbai - 400072 Ph : 91-22-61738700 / 21 , Fax : 91-22-67054548
  </p>
</div>
<div class="logo" *ngIf="icId == 88">  
  <img src="{{imagePath}}">   
  <p class="address">
    P.O.BOX 979, MANAPAKKAM, CHENNAI 600 089 INDIA - PHONE: 044 2270 4694  
  </p>
  <div style="width: 50%;">
    <span style="width: 20%;float: left;"><p>FAX:</p></span>
    <span style="width: 20%;float: left;"><p>E-MAIL:</p></span>
  </div> 
  <p style ="text-align: right;clear: both;">Format No: EDRC-GN-ST-04-1-R0</p>
</div>
<div class="logo" *ngIf="icId != 13312 && icId != 88">
  <img src="{{imagePath}}">   
  <p class="address">
    Mount Poonamallee Road, P.O.Box 979, Manapakkam , Chennai - 600089 Ph : 91-44-2252 6000 / 2252 8000 , Fax :
    91-44-2252 6042
  </p>
  <p class="address">
   L&T Business Park, Gate -5 Powai , Mumbai - 400072 Ph : 91-22-61738700 / 21 , Fax : 91-22-67054548
  </p>
</div>
<table id="tabHeader" cellpadding="1" cellspacing="1" width="100%">
  <tr>
    <td style="text-align: center;">
      <label style="text-align: center; text-decoration: underline;"><b>DRAWING / DOCUMENT TRANSMITTAL</b></label>
    </td>
  </tr>
</table>
<table cellpadding="0" cellspacing="0" width="100%" style="border:1px solid black; border-collapse:collapse;">
  <tr>
    <td style="text-align: left; width: 10%; border:1px solid black" rowspan="3">
      <label Width="100%" style="font-family: Arial Narrow; Font-Size: 0.9em ;text-align: center;">To</label>
    </td>
    <td rowspan="3" style="text-align: left; width: 40%; border:1px solid black ">  
      <span style="word-break: break-word;" [innerHtml]="to"></span>
    </td>
    <td style="text-align: left; width: 15%; border:1px solid black">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em">Date:</label>
    </td>
    <td style="text-align: left; width: 35%; border:1px solid black">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em">{{date}}</label>
    </td>
  </tr>
  <tr>
    <td style="text-align: left; width: 15%; border:1px solid black">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em">EDRC Ref:</label>
    </td>
    <td style="text-align: left; width: 35%; border:1px solid black">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em">{{edrcRef}}</label>
    </td>
  </tr>
  <tr>
    <td style="text-align: left; width: 15%; border:1px solid black">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em">CUST Ref:</label>
    </td>
    <td style="text-align: left; width: 35%; border:1px solid black">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em">{{cusRef}}</label>
    </td>
  </tr>
  <tr>
    <td style="text-align: left; width: 10%; border:1px solid black">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em">Project</label>
    </td>
    <td style="text-align: left; width: 90%; border:1px solid black" colspan="3">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em;"><b>{{projName}}</b></label>
    </td>
  </tr>
  <tr>
    <td style="text-align: left; width: 10%; border:1px solid black">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em">Subject</label>
    </td>
    <td style="text-align: left; width: 90%; border:1px solid black" colspan="3">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em;"><b>{{subject}}</b></label>
    </td>
  </tr>
  <tr>
    <td style="text-align: left; width: 10%; border:1px solid black">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em">Kind Attn.</label>
    </td>
    <td style="text-align: left; width: 90%; border:1px solid black" colspan="3">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em"><b>{{attention}}</b></label>
    </td>
  </tr>
</table>
<table width="100%" >
  <tr>
    <td style="width: 2%"></td>
    <td style="width: 98%; text-align: left">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em">Please find enclosed the following drawings / document
        as
        per the list given below :</label>
    </td>
  </tr>
</table>
<table id="documentGrid" ellpadding="0" cellspacing="0" width="100%"
  style="border:1px solid black; border-collapse:collapse;Font-Size: 0.9em;">
  <thead>
    <tr>
      <th scope="col" style="border:1px solid black; border-collapse:collapse; text-align: center;">
        Serial</th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">Signed Copies
        <i class="fa fa-download" aria-hidden="true" style="cursor: pointer; font-size: 20px; float: left;"
          title="Download All" *ngIf="message_id>0" (click)="downloadAll_OnClick()"></i>
      </th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">Title</th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">Document No</th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">Rev No</th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">No of Copies</th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">Category</th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">Type</th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">Remarks</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let doc of docDetails;let i=index">
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">
        {{i+1}}</td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">
        <i aria-hidden="true" class="eip-link" class="fa fa-paperclip fs-16 eip-mr-5"
          (click)="viewAttachmentClick(doc)"></i>
      </td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">{{doc.doc_Title}}</td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;"><a target="_blank"
          href="{{hyperlink}}">{{doc.doc_No}}</a>
      </td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">{{doc.revision_No}}</td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">{{doc.quantity}}</td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">{{doc.category_Short_Description}}
      </td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">{{doc.type_Short_Description}}</td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">{{doc.remarks}}</td>
    </tr>
  </tbody>
</table>
<br>
<table id="documentGrid" cellpadding="0" cellpadding="0" cellspacing="0" width="100%" style="border:1px solid black; border-collapse:collapse;Font-Size: 0.9em;" 
 *ngIf="fileDetails && fileDetails.length>0">
  <thead>
    <tr>
      <th scope="col" style="border:1px solid black; border-collapse:collapse; text-align: center;">
        Serial</th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">Download
        <i class="fa fa-download" aria-hidden="true" style="cursor: pointer; font-size: 20px; float: left;"
          title="Download All" *ngIf="message_id>0" (click)="downloadAll_OnClick(true)"></i>
      </th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">Title</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let doc of fileDetails;let i=index">
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">
        {{i+1}}</td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">
        <i *ngIf="doc.fileId > 0" aria-hidden="true" class="eip-link" class="fa fa-download fs-16 eip-mr-5"
          (click)="download_OnClick(doc)"></i>
      </td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">{{doc.fileName}}</td>
    </tr>
  </tbody>
</table>

<table width="100%" cellpadding="2" cellspacing="2">
  <tr>
    <td style="text-align: left; width: 98%">
      <label style="font-family: Arial Narrow; Font-Size: 0.9em">* This revision supersedes the previous revision if any
        , of drgs / docs. Superseded drgs. / docs. shall be removed from all point of issue and / or use</label>
    </td>
  </tr>
  <tr>
    <td style="text-align: left; width: 98%">NOTE :
      <label style="font-family: Arial Narrow; Font-Size: 0.9em">{{message_Note}}</label>
    </td>
  </tr>
</table>
<table ellpadding="0" cellspacing="0" width="100%"
  style="border:1px solid black; border-collapse:collapse;Font-Size: 0.9em">
  <thead>
    <tr>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">
        Sl. No.</th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">Name</th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">No of Copies</th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">Category</th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">Type</th>
      <th scope="col" style="border:1px solid black; border-collapse:collapse;text-align: center;">Remarks</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let distDtl of distributionDetails;let i=index">
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">{{i+1}}</td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">{{distDtl.member_Name}}</td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">{{distDtl.quantity}}</td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">
        {{distDtl.category_Short_Description}}</td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">{{distDtl.type_Short_Description}}
      </td>
      <td style="border:1px solid black; border-collapse:collapse;text-align: center;">{{distDtl.remarks}}</td>
    </tr>
  </tbody>
</table>

<table cellpadding="0" cellspacing="0" width="100%"  style="border-width: 1Px;">
  <tbody>
    <td><b>CATEGORY:</b>
      <table ellpadding="0" cellspacing="0" width="100%"
        style="border:1px solid black; border-collapse:collapse;Font-Size: 0.9em" >
        <tbody>
          <tr>
            <td style="border:1px solid black; border-collapse:collapse;" >
              A - For Approval</td>
            <td style="border:1px solid black; border-collapse:collapse;Font-Size: 0.9em" >I - For
              Information</td>
            <td style="border:1px solid black; border-collapse:collapse;" >B - As Build</td>
          </tr>
          <tr>
            <td style="border:1px solid black; border-collapse:collapse;" >
              P - Preliminary</td>
            <td style="border:1px solid black; border-collapse:collapse;" >G - Good For
              Construction</td>
            <td style="border:1px solid black; border-collapse:collapse;" >T - For Tender
              Purpose</td>
          </tr>
        </tbody>
      </table>
    </td>
    <td><b>TYPE:</b>
      <table cellpadding="0" cellspacing="0" width="100%"
        style="border:1px solid black; border-collapse:collapse;Font-Size: 0.9em">
        <tbody>
          <tr>
            <td style="border:1px solid black; border-collapse:collapse;">CD - Compact Disc
            </td>
            <td style="border:1px solid black; border-collapse:collapse;">TR - Tracing</td>
            <td style="border:1px solid black; border-collapse:collapse;">SC - Soft Copy</td>
          </tr>
          <tr>
            <td style="border:1px solid black; border-collapse:collapse;">PR - Prints</td>
            <td style="border:1px solid black; border-collapse:collapse;">TC - Transmittal Copy</td>
            <td style="border:1px solid black; border-collapse:collapse;">HC - Hard Copy</td>
          </tr>
        </tbody>
      </table>
    </td>
    <tr>
    </tr>
  </tbody>
</table>
<table width="100%"  cellpadding="0" cellspacing="0" style="font-family: Arial Narrow; Font-Size: 0.9em">
  <tr>
    <td style="width: 2%"></td>
    <td style="width: 98%; text-align: left" colspan="2">
      Thanking you and assuring you of our best services at all times.
    </td>
  </tr>
  <tr>
    <td style="width: 2%"></td>
    <td style="width: 98%; text-align: left" colspan="2"></td>
  </tr>
  <tr>
    <td style="width: 2%"></td>
    <td style="width: 98%; text-align: left" colspan="2">
      This is system generated DTN and does not require signature.
    </td>
  </tr>
  <tr>
    <td style="width: 2%"></td>
    <td style="width: 68%"></td>
    <td style="width: 30%; text-align: center;"> Yours faithfully,
    </td>
  </tr>
</table>
<table width="100%"  cellpadding="2" cellspacing="2" style="font-family: Arial Narrow; Font-Size: 0.9em">
  <tr>
    <td style="width: 100%" colspan="3"></td>
  </tr>
  <tr>
    <td style="width: 2%"></td>
    <td style="width: 68%"></td>
    <td style="width: 30%; text-align: center;"><b>{{From}}</b>
    </td>
  </tr>
  <tr>
    <td style="width: 2%"></td>
    <td style="width: 68%"></td>
    <td style="width: 30%; text-align: center;"><b>LARSEN & TOUBRO LTD</b>
    </td>
  </tr>
</table>